import { render, staticRenderFns } from "./extraDetailModal.vue?vue&type=template&id=b2ed4852&scoped=true&"
import script from "./extraDetailModal.vue?vue&type=script&lang=js&"
export * from "./extraDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./extraDetailModal.vue?vue&type=style&index=0&id=b2ed4852&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ed4852",
  null
  
)

export default component.exports